import React, { lazy, Suspense, useEffect, useState, type ComponentType } from 'react'

/**
 * Wraps a dialog or menu whose code should only be fetched the first time it opens, so it
 * stays out of the entry bundle. Nothing renders until the first `open`; after that the
 * component stays mounted, as it did when imported statically, so close transitions play.
 */
export function lazyOnOpen<P extends { open: boolean }>(loader: () => Promise<{ default: ComponentType<P> }>): React.FC<P> {
    const Lazy = lazy(loader)
    const LazyOnOpen: React.FC<P> = (props) => {
        const [mounted, setMounted] = useState(props.open)

        useEffect(() => {
            if (props.open) setMounted(true)
        }, [props.open])

        if (!mounted) return null
        return (
            <Suspense fallback={null}>
                <Lazy {...props} />
            </Suspense>
        )
    }
    return LazyOnOpen
}
